module.exports = __webpack_public_path__ + "img/new_spotd1.784dc26d.gif";